/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useContext, useEffect } from 'react';
import Loader from '../../loader';
import './manage-stakeholder-group.scss';
import G17Client from '../../../services/G17Client';
import { TeamMemberPopup } from './TeamMemberPopup';
import { AssuranceRoles } from '../../../constants/assurance';
import { ACTION, TeamMemberContext } from './TeamMemberContainer';
import { useAppSelector } from '../../../reducers';
import { getCurrentUser } from '../../../selectors/user';
import NotAuthorised from '../../../routes/not-authorised';
import { OrganizationAssurancePortfolio } from '../../../types/assurance';

export const ManageStakeholderGroup = ({ assurancePortfolio }: { assurancePortfolio: OrganizationAssurancePortfolio }) => {
  const { portfolioData, submitData, dispatch } = useContext(TeamMemberContext);
  const currentUser = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (!portfolioData.loading && !portfolioData.loaded && !portfolioData.errored) {
      dispatch({
        type: ACTION.SET_PORTFOLIO_DATA,
        payload: {
          loading: true,
        },
      });
      G17Client.getAssurancePermissions(assurancePortfolio._id)
        .then((data) => {
          return dispatch({
            type: ACTION.SET_PORTFOLIO_DATA,
            payload: {
              data: {
                assurers: {
                  [AssuranceRoles.ADMIN]: data.assurers.filter((assurer) => assurer.isAdmin),
                  [AssuranceRoles.USER]: data.assurers.filter((assurer) => assurer.isUser),
                },
                organizationId: data.organizationId,
                portfolioId: assurancePortfolio._id,
              },
              loaded: true,
              loading: false,
            },
          });
        })
        .catch((e) => {
          dispatch({
            type: ACTION.SET_PORTFOLIO_DATA,
            payload: {
              loading: false,
              errored: true,
              errorMessage: e.message,
            },
          });
        });
    }
  }, [portfolioData, assurancePortfolio._id, dispatch]);

  if (!portfolioData.loaded || submitData.submitting) {
    return <Loader />;
  }

  if (!assurancePortfolio?.assurers || !assurancePortfolio?.assurers.some(assurer => assurer._id === currentUser?._id)) {
    return <NotAuthorised />;
  }

  return (
    <div className={'add-stakeholder'}>
      <div>
        <div className='ml-2'>
          <p>All the Assurers currently assigned access to the Assurance Tracker</p>
        </div>
        <div className='mt-3'>
          <div className='pb-2 pb-lg-0 pr-lg-0 d-flex user-wrapper'>
            {Object.values(AssuranceRoles).map((role) => (
              <TeamMemberPopup key={role} role={role} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
